module.exports = __webpack_public_path__ + "504e425cc02dfdb754c807822c565592.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/book-covers/book-3.png
// module id = 2935
// module chunks = 0